import React, { createContext, useState } from 'react';
import { FilterConfig } from "./Enums.js";

// Create the context
export const DataContext = createContext();

// Create a provider component
export const DataProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [projects, setProjects] = useState([]);
    const [forms, setForms] = useState([]);
    const [submissions, setSubmissions] = useState(null);
    const [reviews, setReviews] = useState(null);
    const [allSubmissions, setAllSubmissions] = useState([]);
    const [hiddenSubmissions, setHiddenSubmissions] = useState(null);
    const [hiddenReviews, setHiddenReviews] = useState(null);
    const [filterConfig, setFilterConfig] = useState(FilterConfig.ALL);
    const [users, setUsers] = useState([]);
    const [events, setEvents] = useState([]);
    const [currentProject, setCurrentProject] = useState(null);
    const [currentForm, setCurrentForm] = useState(null);
    const [currentView, setCurrentView] = useState(null);
    const [currentProjectToken, setCurrentProjectToken] = useState(null);
    const [currentAccountToken, setCurrentAccountToken] = useState(null);
    const [submissionToken, setSubmissionToken] = useState([]);
    const [reviewingTokens, setReviewingTokens] = useState([]);
    const [submitters, setSubmitters] = useState([]);
    const [reviewers, setReviewers] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [dataFetched, setDataFetched] = useState(false);

    // Provide the context values
    return (
        <DataContext.Provider value={{
            user, setUser,
            accounts, setAccounts,
            projects, setProjects,
            forms, setForms,
            submissions, setSubmissions,
            reviews, setReviews,
            hiddenSubmissions, setHiddenSubmissions,
            hiddenReviews, setHiddenReviews,
            filterConfig, setFilterConfig,
            allSubmissions, setAllSubmissions,
            users, setUsers,
            events, setEvents,
            currentProject, setCurrentProject,
            currentForm, setCurrentForm,
            currentView, setCurrentView,
            currentProjectToken, setCurrentProjectToken,
            currentAccountToken, setCurrentAccountToken,
            submissionToken, setSubmissionToken,
            reviewingTokens, setReviewingTokens,
            submitters, setSubmitters,
            reviewers, setReviewers,
            admins, setAdmins,
            allUsers, setAllUsers,
            dataFetched, setDataFetched
        }}>
            {children}
        </DataContext.Provider>
    );
};
